/**
 * Persistenza della sessione, senza React.
 *
 * Separata dal provider per lo stesso motivo di `src/app/theme.ts`: deve poter
 * essere letta sincronicamente all'avvio, senza dipendere dal ciclo di vita di
 * un componente.
 */

const STORAGE_KEY = 'dashboard:session'

export interface StoredSession {
  token: string
  username: string
}

function isStoredSession(value: unknown): value is StoredSession {
  return (
    typeof value === 'object' &&
    value !== null &&
    typeof (value as StoredSession).token === 'string' &&
    typeof (value as StoredSession).username === 'string'
  )
}

/** La sessione salvata, o null se non c'è o non è nella forma attesa. */
export function getStoredSession(): StoredSession | null {
  try {
    const raw = localStorage.getItem(STORAGE_KEY)
    if (!raw) return null
    const parsed = JSON.parse(raw) as unknown
    return isStoredSession(parsed) ? parsed : null
  } catch {
    // Storage bloccato o valore corrotto: si procede senza sessione, non si
    // fa fallire l'avvio dell'app per una preferenza che non serve a nulla di
    // critico.
    return null
  }
}

export function storeSession(session: StoredSession): void {
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(session))
  } catch {
    // Niente persistenza in questa sessione: non è un errore da segnalare.
  }
}

export function clearStoredSession(): void {
  try {
    localStorage.removeItem(STORAGE_KEY)
  } catch {
    // Idem.
  }
}
